// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { ProjectTypeIdEnum } from 'config/enums'
import { REQUIRED } from 'errors'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { validateNewProjectName, valueIsRequired } from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const error = {}

  if (castToFloat(v.projectTypeId) === ProjectTypeIdEnum.PROTECTION) {
    error.rcnNumber = valueIsRequired(v.rcnNumber)
  } else {
    validateNewProjectName(v, error)
  }

  // This value should never be initialized as falsy but just in case, make it required.
  if (!v.projectTypeId) {
    error.projectTypeId = REQUIRED
  }

  return error
}

export default validate
